import { render, staticRenderFns } from "./ConstructionManagers.vue?vue&type=template&id=106cc37f&scoped=true&lang=pug&"
import script from "./ConstructionManagers.vue?vue&type=script&lang=js&"
export * from "./ConstructionManagers.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionManagers.vue?vue&type=style&index=0&id=106cc37f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cc37f",
  null
  
)

export default component.exports